import React from 'react'
import GptSearchBar from "./GptSearchBar"
import GptMovieSuggestion from "./GptMovieSuggestion"
import Bgimg from "../Assets/IN-en-20240226-popsignuptwoweeks-perspective_alpha_website_small.jpg";

export const 
GptSearch = () => {
  return (
    <div className="">
    <div className='fixed -z-10 '>
          <img className="h-screen object-cover sm:h-screen sm:object-cover md:h-full md:w-screen" src={Bgimg} alt="Bg-img" />
    </div>
    <div className=''>
        <GptSearchBar/>
        <GptMovieSuggestion/>
    </div>
    </div>
  )
}
